// extracted by mini-css-extract-plugin
export default {"feature_heading":"style_feature_heading__ILOxG","card_row":"style_card_row__7Nr29"};